import axios from "axios"
import { ticketBaseURL } from "../config/api"

export const post_MyCdirCreditCard = async (data: any, userId: number) => {
    const response = await axios({
        url: `${ticketBaseURL}mycdirCreditCard?userId=${userId}`,
        method: "POST",
        headers: {          
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const delete_MyCdirCreditCard = async (primaryKey: number) => {
    const response = await axios({
        url: `${ticketBaseURL}mycdirCreditCard`,
        method: "DELETE",
        params: { id: primaryKey }
    });
    return response.data;
}

export const put_MyCdirCreditCard = async (data: any, userId: number) => {
    const response = await axios({
        url: `${ticketBaseURL}mycdirCreditCard?userId=${userId}`,
        method: "PUT",
        headers: {          
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const getMyCdirCreditCards = () => {
    return getFetch("mycdirCreditCard")
}

export const getMyCdirCreditCard = (primaryKey: string) => {
    return getFetch(`mycdirCreditCard/${primaryKey}`)
}

export const getMyCdirCreditCardWithTenantIdAndIsActive = (tenantId: string) => {
    return getFetch(`mycdirCreditCard/GetMyCdirCreditCardByTenantIdAndIsActiveWithValidExpiryDate/${tenantId}`)
}

export const getMyCdirCreditCardWithTenantId = (tenantId: string, page: number, size: number) => {
    return getFetch(`mycdirCreditCard/GetMyCdirCreditCardsPagingByTenantId/${tenantId},${page},${size}`)
}

const getFetch = (url: string, params = {}) => {
    return axios({
        url: ticketBaseURL + url,
        method: "GET",       
        params: params
    }).then(response => response.data);
}